"use client";
import { j as e } from "./index.es176.js";
import { forwardRef as m, useMemo as c } from "react";
import { makeUniqueId as h } from "./index.es282.js";
m(
  ({
    label: i,
    isChecked: r,
    onChange: s,
    isDefaultChecked: o,
    isDisabled: l,
    inputId: a,
    ...t
  }, n) => {
    const d = c(() => h(), []);
    return /* @__PURE__ */ e.jsxs("div", { className: "bl-radio-button", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          ...t,
          ref: n,
          type: "radio",
          id: a || d,
          onChange: s,
          defaultChecked: o,
          disabled: l,
          checked: r
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: a || d, children: i })
    ] });
  }
);
//# sourceMappingURL=index.es179.js.map
